import React from 'react'

const Navdots = ({ active }) => {
  return (
    <div className='app__navigation mmd:flex hidden  flex-col justify-center items-center p-4'>
      {[
        'home',
        'about',
        'skills',
        'exprience',
        'work',
        'testimonails',
        'contact',
      ].map((link, index) => (
        <a
          href={`#${link}`}
          key={link + index}
          className='app__navigation-dot w-[10px] h-[10px] rounded-full bg-[#cbcbcb] m-2 transition-colors '
          style={active === link ? { backgroundColor: '#313BAC' } : {}}
        />
      ))}
    </div>
  )
}

export default Navdots
